import React, { useContext } from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { Loader, LoadersContainer } from '@/app/components/search/components/EvolutionCard/Loaders/styled.ts';
import { SearchPageContext } from '@/app/components/search/components/SearchPageContainer/SearchPageContext.ts';

type CardLoaderProps = {
  isOverlay: boolean;
};

const CardDetailsLoader = ({ isOverlay }: CardLoaderProps) => {
  const { isMobile } = useCommonClient();
  const { listView } = useContext(SearchPageContext);

  if (isOverlay) {
    return (
      <LoadersContainer>
        <Loader elWidth={195} elHeight={22} style={{ marginBottom: 12 }} />
        <Loader elWidth={254} elHeight={18} style={{ marginBottom: isMobile ? (isOverlay ? 12 : 0) : 24 }} />
      </LoadersContainer>
    );
  }

  if (listView) {
    return (
      <LoadersContainer>
        <Loader elWidth={195} elHeight={22} style={{ marginBottom: 12 }} />
        <Loader elWidth={254} elHeight={18} style={{ marginBottom: 24 }} />
        <Loader elWidth={168} elHeight={16} style={{ marginBottom: 12 }} />
        <Loader elWidth={368} elHeight={16} style={{ marginBottom: 24 }} />
      </LoadersContainer>
    );
  }

  return (
    <LoadersContainer>
      <Loader elWidth={277} elHeight={22} style={{ marginBottom: 8 }} />
      <Loader elWidth={187} elHeight={22} style={{ marginBottom: 12 }} />
      <Loader elWidth={243} elHeight={16} style={{ marginBottom: 24 }} />
      {/* TODO: are these shimmers needed? They seem related to the inline reviews that we're not displaying right now */}
      {/* <Loader elWidth={161} elHeight={16} style={{ marginBottom: 16 }} /> */}
      {/* <Loader elWidth={243} elHeight={16} style={{ marginBottom: 24 }} /> */}
    </LoadersContainer>
  );
};

export default CardDetailsLoader;
